

import { useEffect, useState } from 'react';
import { Heading, InfoPanel, TypographyColor, TypographyType } from '../../ui-elements';
import * as Constants from '../../utils/constants/Constants';
import { LineChartComponentCat } from '.';

interface GrowthInTimeChartProps {
    headerText: string,
    infoText: string,
    data: any,
    color: string,
    breakDownType: string,
    setSelectedYear: (selectedYear: string) => void,
    selectedYear: string,
}

export const GrowthInTimeCategoryLineChart = ({ headerText, infoText, data, color, breakDownType, selectedYear, setSelectedYear }: GrowthInTimeChartProps) => {

    const [selectedDropDownData, setSelectedDropDownData] = useState(data[0].name);
    const [selectedDataIndex, setSelectedDataIndex] = useState(0);
    const [lineChartData, setLineChartData] = useState<any[]>([]);

    useEffect(() => {
        setLineChartData(data);
    }, [data]);

    // useEffect(() => {
    //     if (selectedCategory && headerText !== "Sub District" && headerText !== "Pin Code" && headerText !== "Sub Category") {
    //         setSelectedDropDownData(selectedCategory.name);
    //     } else {
    //         setSelectedDropDownData(data[0].name);
    //     }
    // }, [selectedCategory, geoCode, data]);

    useEffect(() => {
        const index = lineChartData.findIndex(
            (item: any) => item.name.toString().trim() === selectedDropDownData.toString().trim()
        );
        setSelectedDataIndex(index !== -1 ? index : 0); // Default to 0 if not found
    }, [selectedDropDownData, lineChartData]);

    const handleyearChange = (year: string) => {
        setSelectedYear(year); // Update the selected year when clicked
    };

    return (
        <div style={{ height: '', width: '100%', display: 'flex', flexDirection: 'column' }}>
            <div
                className='w-100 d-flex flex-row justify-content-between align-items-end margin-bottom-4'
            >
                <div className="w-50 d-flex flex-row justify-content-start align-items-center">
                    <Heading
                        title={`Growth of Pols over time for ${headerText}`}
                        type={TypographyType.h5}
                        colour={TypographyColor.secondary}
                        classname='text-start'
                    />
                    <InfoPanel text={infoText} classname='margin-left-2 fs-14' />
                </div>
                <div
                    className="w-50 margin-top-3 height-4vh w-25 d-flex flex-row justify-content-end" style={{ gap: '1.320vw' }}
                >
                    <div
                        style={{ borderRadius: '0.703125vh', }}
                        className="linerchart-border-color margin-bottom-2 w-25 height-4vh d-flex flex-row justify-content-between align-items-center"
                    >
                        {Constants.yearHeader.map((item) => (
                            <Heading
                                title={`${item}${item === "1" ? "Yr" : "Yrs"}`}
                                type={TypographyType.h5}
                                colour={TypographyColor.primary}
                                classname={`margin-left-2 margin-right-2 height-4vh d-flex align-items-center ${selectedYear === item && "border-b-black-sm"}`}
                                onClick={() => handleyearChange(item)}
                                key={item}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <div style={{ borderRadius: '0.814vh', borderColor: '#F4F4F4' }} className='w-100 border d-flex flex-column align-items-center justify-content-center'
            >
                <div className="p-4 w-100">
                    <LineChartComponentCat
                        graphData={lineChartData}
                        selectedData={selectedDropDownData}
                        selectedDataIndex={selectedDataIndex}
                        setSelectedDataIndex={setSelectedDataIndex}
                        color={color}
                        headerText={headerText}
                        breakDownType={breakDownType}
                        selectedYear={selectedYear}
                    />
                </div>
                <div className="w-100 p-4 border-top d-flex flex-row justify-content-center align-items-center gap-3">
                    {lineChartData?.[selectedDataIndex]?.cagrText?.map((data: any) => 
                        (<div className='d-flex flex-row justify-content-center align-items-center gap-1'>
                        <span className='poi-circle bg-black-1' style={{ backgroundColor: `${data?.color}` }}></span>
                        <Heading
                            title={`${data?.label}`}
                            type={TypographyType.h5}
                            colour={TypographyColor.primary}
                        />
                    </div>))}
                </div>
            </div>
        </div>
    );
};

